import { animate, group, query, style, transition, trigger } from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition(
    ':increment',
    [
      style({ position: 'relative' }),
      query(':enter', [
        style({
          position: 'absolute',
          top: 'calc({{top}}px - 50vh)',
          left: 'calc({{left}}px - 50vw)',
          transform: 'scale(0)',
          backgroundColor: 'inherit',
        }),
      ]),
      query(':leave', [
        style({
          opacity: 1,
        }),
      ]),
      group([
        query(':leave', [animate('300ms ease-out', style({ opacity: 0 }))]),
        query(':enter', [animate('300ms ease-out', style({ top: '0', left: '0', transform: 'scale(1)' }))]),
      ]),
    ],
    { params: { top: '300', left: '30' } },
  ),
  transition(':decrement', [
    style({ position: 'relative' }),
    query(':leave', [
      style({
        backgroundColor: 'inherit',
        zIndex: 1,
        position: 'absolute',
        top: '1.25rem',
        left: '0px',
        opacity: 1,
        transform: 'scale(1)',
        borderRadius: 0,
        height: '100dvh',
        width: '100dvw',
        overflow: 'hidden',
      }),
    ]),
    group([
      query(':leave', [
        animate(
          '300ms ease-out',
          style({
            top: '0',
            left: '0',
            backgroundColor: 'white',
            transform: 'scale(0.3, 0.1)',
            borderRadius: '5rem',
            opacity: 0,
          }),
        ),
      ]),
    ]),
  ]),
]);
